// Public, sanitised legal trust summary for a rental business profile.
// Component-specific statements only; never a document, reference number or
// broad "legal"/"certified" claim. Links to what ConfirmPH verifies.
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

const TONE = {
  VERIFIED: "border-emerald-200 bg-emerald-50 text-emerald-800",
  EXPIRED: "border-rose-200 bg-rose-50 text-rose-700",
  NOT_VERIFIED: "border-slate-200 bg-slate-50 text-slate-600",
};
const LABEL = { VERIFIED: "Evidence reviewed", EXPIRED: "Reviewed evidence expired", NOT_VERIFIED: "Not verified" };

export default function PublicLegalTrust({ trust }) {
  if (!trust) return null;
  return (
    <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-testid="rp-legal-trust">
      <div className="rounded-xl border border-slate-200 bg-white p-5">
        <h2 className="font-display text-lg font-semibold text-slate-900 inline-flex items-center gap-2">
          <ShieldCheck className="w-5 h-5" /> What ConfirmPH has reviewed
        </h2>
        <ul className="mt-3 space-y-2">
          {trust.items.map((item) => (
            <li key={item.label} className="flex flex-wrap items-start justify-between gap-2 text-sm">
              <span className="text-slate-800"><span className="font-medium">{item.label}:</span> {item.text}
                {item.valid_through ? ` (valid through ${item.valid_through})` : ""}
                {item.verified_month ? ` · reviewed ${item.verified_month}` : ""}</span>
              <span className={`rounded-full border px-2 py-0.5 text-xs ${TONE[item.state] || TONE.NOT_VERIFIED}`}>
                {LABEL[item.state] || item.state}
              </span>
            </li>
          ))}
          <li className="text-sm text-slate-700">{trust.fleet.registration_text}</li>
          <li className="text-sm text-slate-700">{trust.fleet.insurance_text}</li>
          <li className="text-sm text-slate-700">{trust.overall.text}</li>
          <li className="text-sm text-slate-700">{trust.block_text}</li>
        </ul>
        {trust.last_reviewed && <p className="mt-2 text-xs text-slate-500">Last reviewed: {trust.last_reviewed}</p>}
        <details className="mt-3 text-xs text-slate-600">
          <summary className="cursor-pointer underline">What does this mean?</summary>
          <p className="mt-1">{trust.disclaimer}</p>
          <p className="mt-1">ConfirmPH did not verify:</p>
          <ul className="list-disc pl-5">{trust.not_verified_by_confirmph.map((t) => <li key={t}>{t}</li>)}</ul>
          <Link to={trust.what_this_means_path} className="underline">How ConfirmPH verifies</Link>
        </details>
      </div>
    </section>
  );
}
